var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',[_c('transition',{attrs:{"name":"bounce"}},[(_vm.defeated)?_c('div',[_c('h5',{staticClass:"text-center"},[_vm._v(" Tiempo restante para próximo cargue de turno ")]),_c('div',{staticClass:"alert alert-secondary digital-clock text-center"},[_vm._v(" "+_vm._s(_vm._f("performanceDate")(_vm.timerOutput))+" ")])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }